const headers = {
  Accept: 'application/json',
  'X-Requested-With': 'XMLHttpRequest',
};

async function readJson(response) {
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.json();
}

// POSTs `data` form-encoded, the same way $.ajax did, so MVC model binding is unchanged.
export async function postForm(url, data) {
  return readJson(await fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers,
    body: new URLSearchParams(data),
  }));
}

// POSTs with the values in the query string and an empty JSON body, as the
// $.ajax({ type: 'POST', url: url + '?id=…', contentType: 'application/json' }) calls did.
export async function postQuery(url, params) {
  return readJson(await fetch(`${url}?${new URLSearchParams(params)}`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { ...headers, 'Content-Type': 'application/json' },
  }));
}

// For endpoints that return a partial view.
export async function postHtml(url, data) {
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
    body: new URLSearchParams(data),
  });

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.text();
}

// Like jQuery's .html(): the partials include <script>s (TablePaging's) that must run.
export function setHtml(element, html) {
  element.replaceChildren(document.createRange().createContextualFragment(html));
}

export async function getJson(url, params) {
  const query = params ? `?${new URLSearchParams(params)}` : '';

  return readJson(await fetch(`${url}${query}`, { credentials: 'same-origin', headers }));
}

// The controllers answer AJAX calls with { statusCode, data, message, isRefresh }.
export function handleResult(response, onSuccess) {
  if (response && response.statusCode === 200 && response.data !== undefined) {
    onSuccess?.(response.data);
    window.showSuccessMessage(response.message);
    return true;
  }

  window.showErrorMessage(response?.message || 'Something went wrong, please try again.');

  if (response?.isRefresh === true) {
    reloadSoon();
  }

  return false;
}

export function reloadSoon() {
  setTimeout(() => window.location.reload(), 2500);
}
